/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GroupPageMode {
    PARAGRAPH = 'paragraph',
    PREREQUISITES = 'prerequisites',
    FORM = 'form',
}
